import { useEffect, useRef, useState } from 'react';
import StoryCard from '../components/StoryCard';
import data from '../assets/data.json'
import { Container, Row, Col, Button, Form, InputGroup } from 'react-bootstrap';
import { SearchHeart } from 'react-bootstrap-icons';
import { supabase_stories } from '../utils/supabase';
import { GetStories } from '../utils/story.utils';
import { Stories } from '../types/general';
import { useDebounce } from '../utils/hooks.utils';


// const test = ['story1', 'story2']

type Data = {
  title: string;
  imageURL: string;
  MP3File: string;
}[]



function App() {
  const cleanedData = data as Data
  const [stories, setStories] = useState<Stories[]>([])
  const [search, setsearch] = useState<string>('')
  const [loading, setloading] = useState(false);
  const [page, setPage] = useState<number>(1);
  // const [recordCount, setrecordCount] = useState(0);

  const recordCount = useRef(0)
  const pages = useRef(0)

  // const totalPages = 10; // Replace with your dynamic total page count from Supabase/API

  // This value will only change after the user stops typing for 500ms
  const debouncedSearchTerm = useDebounce(search, 500);



  useEffect(() => {
    if (debouncedSearchTerm) {
      // Execute your API fetch call or heavy logic here
      console.log(`Pinging API for: ${debouncedSearchTerm}`);
    }
  }, [debouncedSearchTerm]);
  useEffect(() => {
    handleGetStories();
  }, [page]);


  // Go to the previous page
  const handlePrev = () => {
    if (page > 1) {
      setPage(page - 1);
      // handleGetStories(); // Fetch stories for the new page
    }
  };

  // Go to the next page
  const handleNext = () => {
    if (page < recordCount.current) {
      setPage(page + 1);
      // handleGetStories(page + 1); // Fetch stories for the new page

    }
  };



  const handleGetStories = async () => {
    setloading(true);
    setStories([]) // Clear the stories before fetching new ones  
    GetStories({ search: debouncedSearchTerm as string, page: page ?? 1 }).then((results) => {
      console.log(results)
      if (!results) {
        alert("Error fetching stories. Please try again later.");
        return
      }
      setStories(results.data || [])

      recordCount.current = results.count || 0
      pages.current = results.pages
      // setrecordCount(results.count || 0)
    }).finally(() => {
      setloading(false);

    });
    console.log(supabase_stories)

  };


  useEffect(() => {
    handleGetStories();
  }, []);


  return (<>

    <Container fluid className='ff_repunzel ' >
      <Row className="justify-content-md-center my-3">
        <Col xs='auto'>
          <h1 className=" display-1 ff_shooting_star">Bedtime Stories</h1>
        </Col>
      </Row>

      <Row className='py-5 justify-content-end' >
        <Col xs='12' lg='5' >

          <InputGroup className="mb-3">
            <Form.Control
              placeholder="Search your Story"
              aria-label="Search Story"
              aria-describedby="Search Filter for Stories"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setsearch(e.target.value)}
            />
            <Button variant="outline-secondary" onClick={handleGetStories} disabled={loading} id="button-addon2">
              <SearchHeart size={'30px'} />
            </Button>
          </InputGroup>
        </Col>
      </Row>

      

      <Row className='gy-5'>
        {/* Row with Horizontal (up and down) gutter spacing. Spacing appears above and below the lines/rows */}

        {stories.map((element, index) => (<>
          <Col xs='12' md='6' lg='4' className='d-flex justify-content-center'>
            {/* Column with takes up 3/12 of the entire row. Any excess is sent to the next line. Note: This does not make a new "ROW" component. 
            Can be adjusted to change the amount of cards displayed per line using the breakpoints (xs,sm,md,lg,xl,xxl), so it adjusts to the with of the screen.
          */}
            <StoryCard title={element.title} imageURL={element.imageURL} MP3File={element.MP3File} />
          </Col>
        </>))

        }

      </Row>
      <Row className="justify-content-md-center m-5">
        <Col xs="12" sm="4" md="3" lg="2"> {/* Adjusted width metrics for better mobile responsiveness */}
          <InputGroup>
            {/* Previous Button */}
            <Button
              variant="outline-secondary"
              onClick={handlePrev}
              disabled={page <= 1 ||  pages.current <= 0 || loading}
            >
              {'<'}
            </Button>

            {/* Dynamic Page Input */}
            <Form.Control
              type="number"
              min={1}
              max={recordCount.current}
              className="text-center"
              aria-label="Page Number"
              disabled
              value={page === 0 ? '' : page} // Render empty string if state is temporarily 0
            // onChange={(e) => handleInputChange(e.target.value)}
            />

            {/* Next Button */}
            <Button
              variant="outline-secondary"
              onClick={handleNext}
              disabled={page >= pages.current ||  pages.current <= 0 || loading}
            >
              {'>'}
            </Button>
          </InputGroup>

          {/* Optional: Visual cue for total pages */}
          <div className="text-center text-muted small mt-1">
            of {pages.current} pages
          </div>
        </Col>
      </Row>
    </Container>

  </>);

}

export default App;
